import React from 'react';
import { Checkbox, Input, Tooltip } from 'antd';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import { IFormItemInputComponent } from 'src/pages/observers/components/FormItemInput/types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import DatePickerWithFormat from 'src/pages/observers/components/DatePickerWithFormat';
import _ from 'lodash';

export default function FormItemInput({
	label,
	tooltip,
	required = false,
	inputType = 'text',
	onInputChange,
	value,
	placeholder,
	readonly,
}: IFormItemInputComponent) {
	return (
		<FormItem>
			<FormLabel>
				{required && '* '}
				{label}
				{tooltip && (
					<Tooltip title={tooltip}>
						<QuestionCircleOutlined
							style={{ color: 'rgba(0,0,0,0.45)', cursor: 'help', }}
						/>
					</Tooltip>
				)}
			</FormLabel>
			{
				inputType === 'number' ? (
					<Input
						disabled={readonly}
						placeholder={placeholder}
						type={inputType}
						onChange={(e) => onInputChange(e.target.value)}
						value={value?.toString()}
					/>
				) : inputType === 'boolean' ? (
					<Checkbox
						disabled={readonly}
						value={Boolean(value)}
						onChange={(e) => onInputChange(e.target.checked)}
					>
						{_.capitalize(value?.toString())}
					</Checkbox>
				) : inputType === 'date' ? (
					<DatePickerWithFormat

						onDateChange={(date) =>
							onInputChange(date)
						}
					/>
				) : (
					<Input
						disabled={readonly}
						placeholder={placeholder}
						type="text"
						onChange={(e) => onInputChange(e.target.value)}
						value={value?.toString()}
					/>
				)
			}
		</FormItem>
	);
}
